import { configureStore } from '@reduxjs/toolkit'
import { setupListeners } from '@reduxjs/toolkit/query'
import authSlice from './slices/authSlice'
import uiSlice from './slices/uiSlice'
import alertSlice from './slices/alertSlice'
import workOrderSlice from './slices/workOrderSlice'
import equipmentSlice from './slices/equipmentSlice'
import { api } from './api'

export const store = configureStore({
  reducer: {
    auth: authSlice,
    ui: uiSlice,
    alerts: alertSlice,
    workOrders: workOrderSlice,
    equipment: equipmentSlice,
    api: api.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
      },
    }).concat(api.middleware),
  devTools: process.env.NODE_ENV !== 'production',
})

setupListeners(store.dispatch)

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

export default store